import styled from 'styled-components'

const Container = styled.div<{ isMobile?: boolean }>`
  display: grid;
  grid-template-columns: 1fr 440px 1fr;
  height: 100vh;
  overflow: hidden;
  margin-top: 3px;

  ${(props) =>
    props.isMobile &&
    `
    margin-top: 0;
    grid-template-columns: 1fr;
    height: 85vh;
  `}
`

const Bar = styled.div<{
  width: string
  height: string
  $marginBottom?: string
  isMobile?: boolean
}>`
  border-radius: 5px;
  background: #eeeeee;
  margin-bottom: ${(props) =>
    props.$marginBottom ? props.$marginBottom : '10px'};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
`

const Column = styled.div`
  position: relative;
  padding: 38px;
  border-right: 1px solid #e5e5e5;
  &:last-child {
    border-right: none;
  }
`

const Center = styled.div`
  display: grid;
  place-items: center;
`

const LightOpaque = styled.div`
  width: 100%;
  height: 160px;
  left: -10px;
  position: absolute;
  transform: rotate(200deg);
  background: #ffffff;
  opacity: 0.45;
`

const LightOpaqueCol1 = styled(LightOpaque)`
  top: 27px;
  left: 0;
  border-radius: 0 0 0 50px;
`

const LightOpaqueCol2 = styled(LightOpaque)`
  top: 205px;
  border-radius: 0 90px 0 80px;
`

const LightOpaqueCol3 = styled(LightOpaque)`
  top: 373px;
  border-radius: 0 90px 0 0;
`

interface LoadingPlaceholderProps {
  isMobile?: boolean
}

const LoadingPlaceholder: React.FC<LoadingPlaceholderProps> = ({
  isMobile,
}) => {
  return (
    <Container data-testid="loading-placeholder-container" isMobile={isMobile}>
      {!isMobile && (
        <Column>
          <Bar width="50%" height="35px"></Bar>
          <Bar width="70%" height="35px"></Bar>
          <Bar width="95%" height="118px"></Bar>
          <LightOpaqueCol1 />
        </Column>
      )}
      <Column>
        <Bar width="60%" height="35px"></Bar>
        <Center>
          <Bar width="90%" height="35px" $marginBottom="22px"></Bar>
          <Bar width="90%" height="350px" $marginBottom="22px"></Bar>
          <Bar width="90%" height="35px"></Bar>
        </Center>
        <LightOpaqueCol2 />
      </Column>
      {!isMobile && (
        <Column>
          <Bar width="60%" height="35px" $marginBottom="30px"></Bar>
          <Bar
            width="90%"
            height="60px"
            style={{
              marginLeft: '10px',
            }}
          ></Bar>
          <Bar width="60%" height="35px" $marginBottom="36px"></Bar>
          <Bar
            width="90%"
            height="250px"
            style={{
              marginLeft: '10px',
            }}
          ></Bar>
          <LightOpaqueCol3 />
        </Column>
      )}
    </Container>
  )
}

export default LoadingPlaceholder
